import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import config from './Config';

const options = {
    order: ['querystring', 'cookie', 'localStorage', /* 'navigator', */ 'htmlTag'],

    // keys or params to lookup language from
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',

    // cache user language on
    caches: ['localStorage'],
};

i18n
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: 'pt',
        detection: options,
        fallbackLng: 'pt',
        ns: ['auth', 'common', 'signin', 'signup', 'surveyfollowup', 'tyre', 'home', 'profile', 'cards', 'contractsinvoices', 'offers', 'exception', 'events', 'subscriptions', 'packages'],
        defaultNS: 'common',
        backend: {
            loadPath: window.location.protocol + '//' + window.location.host + config.BaseURL + '/locales/' + config.BrandEnv + '/{{lng}}/{{ns}}.json',
        },
    }, undefined);

export default i18n;
